<template>

	<!-- <div data-v-7018754c="" data-v-1bf1a862="" class="uni-cursor-point">
		<div data-v-7018754c="" class="uni-fab uni-fab--leftTop">
			<div data-v-7018754c="" elevation="5"
				class="uni-fab__content uni-fab__content--left uni-fab__content--flexDirection uni-fab__content--flexDirectionStart uni-fab__content--other-platform"
				style="width: 55px; height: 230px; background-color: rgb(255, 255, 255);">
				<div data-v-7018754c="" class="uni-fab__item uni-fab__item--first"></div>
				<div data-v-7018754c="" class="uni-fab__item uni-fab__item--active">
					<div data-v-7018754c="" class="uni-fab__item-image" style="height: 26px;">
						<div
							style="background-image: url(&quot;/static/component.png&quot;); background-size: 100% 100%; background-repeat: no-repeat;">
						</div><img src="/static/component.png" draggable="true">
						
					</div>
					<text data-v-7018754c="" class="uni-fab__item-text" style="color: rgb(122, 126, 131);">
						<span>组件</span></text>
				</div>
				<div data-v-7018754c="" class="uni-fab__item uni-fab__item--active">
					<div data-v-7018754c="" class="uni-fab__item-image" style="height: 26px;">
						<div
							style="background-image: url(&quot;/static/apiHL.png&quot;); background-size: 100% 100%; background-repeat: no-repeat;">
						</div><img src="/static/apiHL.png" draggable="true">
					</div>
					<text data-v-7018754c="" class="uni-fab__item-text" style="color: rgb(0, 122, 255);">
						<span>API</span></text>
				</div>
				<div data-v-7018754c="" class="uni-fab__item uni-fab__item--active">
					<div data-v-7018754c="" class="uni-fab__item-image" style="height: 26px;">
						<div
							style="background-image: url(&quot;/static/templateHL.png&quot;); background-size: 100% 100%; background-repeat: no-repeat;">
						</div><img src="/static/templateHL.png" draggable="true">
					</div>
					<text data-v-7018754c="" class="uni-fab__item-text" style="color: rgb(0, 122, 255);">
						<span>模版</span></text>
				</div>
			</div>
		</div>
		<div data-v-7018754c=""
			class="uni-fab__circle uni-fab__plus uni-fab__circle--leftTop uni-fab__content--other-platform"
			style="background-color: rgb(0, 122, 255);">
			<div data-v-7018754c="" class="fab-circle-v uni-fab__plus--active"></div>
			<div data-v-7018754c="" class="fab-circle-h uni-fab__plus--active"></div>
		</div>
	</div> -->
	<div>
		<!-- <div v-if="$store.state.operate!='详情'" @click="okClick()" class="el-backtop " style="right: 40px; bottom: 190px;font-size: 12px;color: #fff;background-color:#2f54eb;">提交</div>
		<div v-if="$store.state.operate=='详情'" @click="editClick()" class="el-backtop " style="right: 40px; bottom: 190px;font-size: 12px;color: #fff;background-color:#2f54eb;">编辑</div>
	<div @click="returnClick()" class="el-backtop " style="right: 40px; bottom: 140px;font-size: 12px;color: #fff;background-color:#2f54eb;">返回</div>
	<div @click="topClick()" class="el-backtop" style="right: 40px; bottom: 90px;color: #8c92a4;"><i class="el-icon-caret-top"></i></div>
	<div @click="bottomClick()" class="el-backtop" style="right: 40px; bottom: 40px;color: #8c92a4;"><i class="el-icon-caret-bottom"></i></div> -->
	
	<!-- <div v-if="$store.state.operate!='详情'" @click="okClick()" class="el-backtop " style="right: 40px; top: 120px;font-size: 12px;color: #fff;background-color:#2f54eb;">提交</div> -->
		<!-- <div v-if="$store.state.operate=='详情'" @click="editClick()" class="el-backtop " style="right: 40px; top: 170px;font-size: 12px;color: #fff;background-color:#2f54eb;">编辑</div> -->
	<!-- <div @click="returnClick()" class="el-backtop " style="right: 40px; top: 170px;font-size: 12px;color: #fff;background-color:#2f54eb;">返回</div> -->
	<div @click="topClick()" class="el-backtop" style="right: 40px; top: 230px;color: #8c92a4;"><i class="el-icon-caret-top"></i></div>
	<div @click="bottomClick()" class="el-backtop" style="right: 40px; top: 280px;color: #8c92a4;"><i class="el-icon-caret-bottom"></i></div>
	</div>
</template>
<script>
	  export default {
		      
	    data() {
	      return {
			  index:0,
			 }
	    },
		
	    methods: {
			editClick(){
				 this.$store.commit("saveOperate", '编辑');
			},
			okClick(){
				if(this.$parent.$children[4]&&this.$parent.$children[4].onSubmit)
				this.$parent.$children[4].onSubmit()
				else if(this.$parent.$children[7]&&this.$parent.$children[7].onSubmit){
					 console.log(7)
					this.$parent.$children[7].onSubmit()
				}
				else if(this.$parent.$children[6]&&this.$parent.$children[6].onSubmit){
					 console.log(6)
					this.$parent.$children[6].onSubmit()
				}
				else if(this.$parent.$children[5]&&this.$parent.$children[5].onSubmit){
					 console.log(5)
					this.$parent.$children[5].onSubmit()
				}
			},
			checkParent(){
				if(this.$parent.$children[4].$refs.scrollRef){
					this.index=4;return true;
				}
				if(this.$parent.$children[5].$refs.scrollRef){
					this.index=5;return true;
				}
				return false;
			},
			topClick(){
				this.$root.$children[0].$refs.containerRef.scrollTop=0
				// if(this.checkParent()){
				// 	this.$parent.$children[this.index].$refs.scrollRef.scrollTop=0;
				// }else{
				// 	//this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop=0;
				// 	// this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop=0;
				// 	this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop=0;
				// }
			},
			bottomClick(){
				this.$root.$children[0].$refs.containerRef.scrollTop=this.$root.$children[0].$refs.containerRef.scrollHeight
			// 	if(this.checkParent()){
			// 		this.$parent.$children[this.index].$refs.scrollRef.scrollTop=this.$parent.$children[this.index].$refs.scrollRef.scrollHeight
			// 	}else{
			// 		//this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop= this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.clientHeight;
			// 	//this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop=this.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollHeight;
			// 		this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollTop=this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$refs.containerRef.$el.scrollHeight;
			
			// 	}
			},
			returnClick(e){
				 this.$store.commit("saveOperate", '');
			// this.$parent.$parent.$emit("callbackPage",{statusText:'返回'}); 
			}
		},
	  }
</script>
<style scoped>
	.uni-fab {
		position: fixed;
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		justify-content: center;
		align-items: center;
		z-index: 10;
	}

	.uni-cursor-point {
		/* #ifdef H5 */
		cursor: pointer;
		/* #endif */
	}

	.uni-fab--active {
		opacity: 1;
	}

	.uni-fab--leftBottom {
		left: 5px;
		bottom: 20px;
		/* #ifdef H5 */
		left: calc(5px + var(--window-left));
		bottom: calc(20px + var(--window-bottom));
		/* #endif */
		padding: 10px;
	}

	.uni-fab--leftTop {
		left: 5px;
		top: 30px;
		/* #ifdef H5 */
		left: calc(5px + var(--window-left));
		top: calc(30px + var(--window-top));
		/* #endif */
		padding: 10px;
	}

	.uni-fab--rightBottom {
		right: 5px;
		bottom: 20px;
		/* #ifdef H5 */
		right: calc(5px + var(--window-right));
		bottom: calc(20px + var(--window-bottom));
		/* #endif */
		padding: 10px;
	}

	.uni-fab--rightTop {
		right: 5px;
		top: 30px;
		/* #ifdef H5 */
		right: calc(5px + var(--window-right));
		top: calc(30px + var(--window-top));
		/* #endif */
		padding: 10px;
	}

	.uni-fab__circle {
		position: fixed;
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		justify-content: center;
		align-items: center;
		width: 55px;
		height: 55px;
		background-color: #3c3e49;
		border-radius: 55px;
		z-index: 11;
	}

	.uni-fab__circle--leftBottom {
		left: 15px;
		bottom: 30px;
		/* #ifdef H5 */
		left: calc(15px + var(--window-left));
		bottom: calc(30px + var(--window-bottom));
		/* #endif */
	}

	.uni-fab__circle--leftTop {
		left: 15px;
		top: 40px;
		/* #ifdef H5 */
		left: calc(15px + var(--window-left));
		top: calc(40px + var(--window-top));
		/* #endif */
	}

	.uni-fab__circle--rightBottom {
		right: 15px;
		bottom: 30px;
		/* #ifdef H5 */
		right: calc(15px + var(--window-right));
		bottom: calc(30px + var(--window-bottom));
		/* #endif */
	}

	.uni-fab__circle--rightTop {
		right: 15px;
		top: 40px;
		/* #ifdef H5 */
		right: calc(15px + var(--window-right));
		top: calc(40px + var(--window-top));
		/* #endif */
	}

	.uni-fab__circle--left {
		left: 0;
	}

	.uni-fab__circle--right {
		right: 0;
	}

	.uni-fab__circle--top {
		top: 0;
	}

	.uni-fab__circle--bottom {
		bottom: 0;
	}

	.uni-fab__plus {
		font-weight: bold;
	}

	.fab-circle-v {
		position: absolute;
		width: 3px;
		height: 31px;
		left: 26px;
		top: 12px;
		background-color: white;
		transform: rotate(0deg);
		transition: transform 0.3s;
	}

	.fab-circle-h {
		position: absolute;
		width: 31px;
		height: 3px;
		left: 12px;
		top: 26px;
		background-color: white;
		transform: rotate(0deg);
		transition: transform 0.3s;
	}

	.uni-fab__plus--active {
		transform: rotate(135deg);
	}

	.uni-fab__content {
		/* #ifndef APP-NVUE */
		box-sizing: border-box;
		display: flex;
		/* #endif */
		flex-direction: row;
		border-radius: 55px;
		overflow: hidden;
		transition-property: width, height;
		transition-duration: 0.2s;
		width: 55px;
		border-color: #DDDDDD;
		border-width: 1rpx;
		border-style: solid;
	}

	.uni-fab__content--other-platform {
		border-width: 0px;
		box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.2);
	}

	.uni-fab__content--left {
		justify-content: flex-start;
	}

	.uni-fab__content--right {
		justify-content: flex-end;
	}

	.uni-fab__content--flexDirection {
		flex-direction: column;
		justify-content: flex-end;
	}

	.uni-fab__content--flexDirectionStart {
		flex-direction: column;
		justify-content: flex-start;
	}

	.uni-fab__content--flexDirectionEnd {
		flex-direction: column;
		justify-content: flex-end;
	}

	.uni-fab__item {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 55px;
		height: 55px;
		opacity: 0;
		transition: opacity 0.2s;
	}

	.uni-fab__item--active {
		opacity: 1;
	}

	.uni-fab__item-image {
		width: 25px;
		height: 25px;
		margin-bottom: 3px;
	}

	.uni-fab__item-text {
		color: #FFFFFF;
		font-size: 12px;
	}

	.uni-fab__item--first {
		width: 55px;
	}
</style>
